export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const scrollIntoView = (ref: Element | null) => {
  ref?.scrollIntoView({
    block: 'center',
    behavior: 'smooth',
  });
};
